import { digitsThree } from "../../../../utils/price";
import moment from "jalali-moment";
import { convertOrderBundleProducts } from "../../helper/convertOrderBundleProducts";

function PrintCard2({ data }) {
  const convertedProduct = convertOrderBundleProducts(data.products || []);
  return (
    <>
      <div className="page-break">
        <div className="w-full mx-auto h-auto py-10 bg-white">
          <div className="w-full p-4">
            <div className="w-full border border-2 rounded-2xl overflow-hidden pb-2">
              <div className="w-full flex justify-between p-4">
                <div className="flex items-cneter justify-center w-48">
                  <p>
                    <img
                      className="w-20 py-2"
                      src={require("./../../../../assets/image/logo.png")}
                      alt="website-logo"
                    />
                  </p>
                </div>
                <div className="text-xl text-gray-800 b-titr">
                  فروشگاه آکادمی هنری مینا
                </div>
                <div className="flex flex-col w-48 text-gray-800 text-sm justify-center gap-1 b-titr">
                  <p>
                    تاریخ :{" "}
                    {moment(data?.paymentDate).locale("fa").format("YYYY/M/D")}
                  </p>
                  <p>شماره فاکتور : #{data?.trackingCode}</p>
                </div>
              </div>

              <div className="w-full px-8">
                <table className="w-full divide-y divide-gray-200 overflowX-scroll">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-2 py-3 text-xs font-medium text-gray-500 text-center"
                      >
                        ردیف
                      </th>
                      <th
                        scope="col"
                        className="px-2 py-3 text-xs font-medium text-gray-500 text-center"
                      >
                        شرح کالا
                      </th>
                      <th
                        scope="col"
                        className="px-2 py-3 text-xs font-medium text-gray-500 text-center"
                      >
                        تعداد
                      </th>
                      <th
                        scope="col"
                        className="px-2 py-3 text-xs font-medium text-gray-500 text-center"
                      >
                        مبلغ واحد (تومان)
                      </th>
                      <th
                        scope="col"
                        className="px-2 py-3 text-xs font-medium text-gray-500 text-center"
                      >
                        مبلغ نهایی (تومان)
                      </th>
                      <th
                        scope="col"
                        className="px-2 py-3 text-xs font-medium text-gray-500 text-center"
                      >
                        QC
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {convertedProduct?.length
                      ? convertedProduct.map((item, index) => {
                          return (
                            <tr className="odd:bg-white even:bg-gray-100">
                              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                                {index + 1}
                              </td>
                              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                                {item?.productName}
                              </td>
                              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                                {item?.count}
                              </td>
                              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                                {!item.inPack
                                  ? digitsThree(item.basePrice)
                                  : "محاسبه شده در پک"}
                              </td>
                              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                                {!item.inPack
                                  ? digitsThree(item.totalPrice)
                                  : "محاسبه شده در پک"}
                              </td>
                              <td className="px-2 py-4 flex justify-center items-center gap-2 whitespace-nowrap text-sm text-gray-800 text-center">
                                {!item.isPack ? (
                                  <>
                                    <div className="border w-4 h-4 border-gray-600 rounded-sm"></div>
                                    <div className="border w-4 h-4 border-gray-600 rounded-sm"></div>
                                  </>
                                ) : null}
                              </td>
                            </tr>
                          );
                        })
                      : null}

                    <tr className=" border-t-2 border-x-2 ">
                      <td
                        colSpan={4}
                        className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"
                      >
                        وضعیت :
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                        تایید شده
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"></td>
                    </tr>
                    <tr className=" border-x-2 ">
                      <td
                        colSpan={4}
                        className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"
                      >
                        مجموع قیمت کالا :
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                        {digitsThree(data?.totalProductsPrice)}
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"></td>
                    </tr>
                    <tr className=" border-x-2 ">
                      <td
                        colSpan={4}
                        className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"
                      >
                        هزینه ارسال :
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                      هزینه ارسال :{" "}
                          {data?.shippingFinalPrice
                            ? `${digitsThree(data?.shippingFinalPrice)} تومان`
                            : "رایگان"}
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"></td>
                    </tr>
                    <tr className="border-x-2  border-b-2">
                      <td
                        colSpan={4}
                        className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"
                      >
                        مجموع پرداختی :
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center">
                        {digitsThree(data?.shippingTotalPrice + data?.totalProductsPrice)}
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 text-center"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {convertedProduct?.length <= 10 && (
          <div className="w-11/12 mx-auto overflow-hidden">
            <div className="my-4 border-t border-b boder-gray-900 py-2"></div>
            <div className="w-full py-4">
              <h3 className="px-2 text-gray-800">اطلاعات مشتری</h3>
              <div className="flex flex-col gap-3 text-gray-700 py-4">
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-6/12 text-md">
                    نام و نام خانوادگی : {data?.name}  {data?.userRole ==="affiliate" ? " ***" : null}
                  </p>
                  <p className="w-6/12 text-md">شماره تماس : {data?.mobile}</p>
                </div>
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-6/12 text-md">کد پستی : {data?.postcode}</p>
                  <p className="w-6/12 text-md">
                    استان : {data && `${data?.province}`}
                  </p>
                </div>
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-6/12 text-md">
                    شهر : {data && `${data?.city}`}
                  </p>
                  <p className="w-6/12 text-md">
                    آدرس : {data && `${data?.address} `}
                  </p>
                </div>
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-full text-md">
                    توضیحات : {data && `${data?.description || "-"} `}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {convertedProduct?.length > 10 && (
        <div className="w-11/12 mx-auto page-break">
          <div className="w-full mx-auto overflow-hidden">
            <div className="my-8 border-t border-b boder-gray-900 py-2"></div>
            <div className="w-full py-4">
              <h3 className="px-2 text-gray-800">اطلاعات مشتری</h3>
              <div className="flex flex-col gap-3 text-gray-700 py-4">
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-6/12 text-md">
                    نام و نام خانوادگی : {data?.name}
                  </p>
                  <p className="w-6/12 text-md">شماره تماس : {data?.mobile}</p>
                </div>
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-6/12 text-md">کد پستی : {data?.postcode}</p>
                  <p className="w-6/12 text-md">
                    استان : {data && `${data?.province}`}
                  </p>
                </div>
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-6/12 text-md">
                    شهر : {data && `${data?.city}`}
                  </p>
                  <p className="w-6/12 text-md">
                    آدرس : {data && `${data?.address} `}
                  </p>
                </div>
                <div className="flex px-4 iems-center gap-4">
                  <p className="w-full text-md">
                    توضیحات : {data && `${data?.description || "-"} `}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PrintCard2;
